import { Component, OnInit } from '@angular/core';
import { RecordsService } from '../records.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-hob-list',
  templateUrl: './hob-list.component.html',
  styleUrls: ['./hob-list.component.css']
})
export class HobListComponent implements OnInit {

  public hob_records = [];

  constructor(private hob_list : RecordsService,private http: HttpClient) { }

  ngOnInit() {
    this.hob_list.getHobRecord()
                         .subscribe(data => this.hob_records = data);
  }

}
